import pois from "./pois";
import loading from "./loading";
import breadcrumb from "./breadcrumb";
import nearbyPois from "./nearbyPois";
import bookmarkLists from "./bookmarkLists";

export default {
  pois,
  loading,
  breadcrumb,
  nearbyPois,
  bookmarkLists,
};



// WEBPACK FOOTER //
// ./assets/pois/reducers/index.js